
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1590581194427",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "21740",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "1024",
    "height": "1024"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M837.376 166.272 187.904 166.272c-41.344 0-75.008 33.28-75.008 74.24l0 544.256c0 40.96 33.536 74.24 75.008 74.24l649.344 0c41.344 0 75.008-33.28 75.008-74.24L912.256 240.512C912.256 199.552 878.72 166.272 837.376 166.272L837.376 166.272M187.904 215.808l649.472 0c13.824 0 24.96 11.136 24.96 24.704l0 291.456c-40.192-32.768-110.08-76.8-193.792-76.8-77.184 0-153.344 59.264-226.944 116.48-56.448 43.904-114.688 89.344-155.648 89.344-57.344 0-106.496-41.728-123.136-57.728L162.816 240.512C162.944 226.816 174.08 215.808 187.904 215.808L187.904 215.808M837.376 809.6 187.904 809.6c-13.824 0-24.96-11.136-24.96-24.704l0-117.504c29.952 20.992 73.216 43.136 123.136 43.136 58.24 0 120.576-48.512 186.496-99.84 66.944-52.096 136.064-105.984 195.968-105.984 107.392 0 192.512 93.568 193.408 94.592l0.384-0.384 0 185.984C862.336 798.464 851.2 809.6 837.376 809.6L837.376 809.6M362.496 512.896c55.296 0 100.096-44.416 100.096-99.072 0-54.784-44.8-99.072-100.096-99.072-55.296 0-100.096 44.416-100.096 99.072C262.4 468.48 307.2 512.896 362.496 512.896L362.496 512.896M362.88 364.16c27.52 0 49.792 22.144 49.792 49.28 0 27.264-22.272 49.28-49.792 49.28-27.52 0-49.792-22.144-49.792-49.28C313.088 386.304 335.36 364.16 362.88 364.16L362.88 364.16M362.88 364.16",
        "p-id": "21741"
      }
    }
  ]
})
    }
  